export default {
  // domain: "http://192.168.1.49:9001/",
  domain: '',

  login: '/manageapi/accountapi/Login',
  verifyCodeImg:'/manageapi/accountapi/VerifyCodeImg?height=35&width=100&fontsize=20&rnd=',
  uploadImg:'/manageapi/uploadapi/image?width=600&height=372',
  getNav: "/manageapi/homeapi/index", // 获取导航
  GetSignature: 'manageapi/upload/GetSignature', // 上传资源

  //导航相关
  updateNav: "/manageapi/confignavmenuapi/update", // 改变导航树
  getNavTreeManage: "/manageapi/confignavmenuapi/get", // 获取导航树
  getRole: "/manageapi/usermanagementapi/getlist", // 获取角色列表
  getNavTree: "/manageapi/rolemanagementapi/getrights", // 获取导航树
  // 角色管理
  addRole: "/manageapi/rolemanagementapi/add", // 添加
  updateRole: "/manageapi/rolemanagementapi/update", // 修改
  deleteRole: "/manageapi/rolemanagementapi/delete", // 删除
  getRoleList: "/manageapi/rolemanagementapi/getlist", // 查询
  // 用户管理
  addUser: "/manageapi/usermanagementapi/add", // 添加
  updateUser: "/manageapi/usermanagementapi/update", // 修改
  deleteUser: "/manageapi/usermanagementapi/delete", // 删除
  getUserList: "/manageapi/usermanagementapi/getlist", // 查询


  // 获取菜单列表
  getMealList: "/manageapi/meal/getmeallist", // 查询
  getAllMealList: "/manageapi/meal/getmealsellist", // 查询
  addOrUpdateMeal: "/manageapi/meal/addorupdatemeal", // 添加修改
  delMeal: "/manageapi/meal/delmeal", // 删除
  // 点餐
  getmealdaylist: "/manageapi/meal/getmealdaylist", // 查询
  addOrUpdateMealDay: "/manageapi/meal/addorupdatemealday", // 添加修改
  delMealDay: "/manageapi/meal/delmealday", // 删除
  // 点餐记录
  getMemOrderRecordList: "/manageapi/meal/getmemorderrecordlist", // 查询
  // 点餐报表
  getMealReportList: "/manageapi/meal/getmealreport", // 查询
}
